<template>
  <v-app>
    <v-app-bar
      app
      color="#312E81"
    >
      <div class="d-flex align-center w-full justify-between white--text ">
        <h2 class="mx-4 leading-0">The Sweetest Running Pace Calculator</h2>
        <router-link to="/" class="white--text mx-2">Home</router-link> |
        <router-link to="/about" class="white--text ml-2"> About</router-link>
      </div>
    </v-app-bar>

    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

<style scoped>
.logo-wrap {
  width: 40px;
}
.w-full {
  width: 100%;
  text-align: center;
}
.leading-0 {
  line-height: 1.3rem;
}
@media(max-width:768px) {
  h2 {
    font-size: 1rem;
  }
}
</style>
